import { render, staticRenderFns } from "./address_list.vue?vue&type=template&id=9c7204a8&scoped=true"
import script from "./address_list.vue?vue&type=script&lang=js"
export * from "./address_list.vue?vue&type=script&lang=js"
import style0 from "./address_list.vue?vue&type=style&index=0&id=9c7204a8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c7204a8",
  null
  
)

export default component.exports